import {
  EdgelessClipboardConfig,
  type PreparedEdgelessBlock,
} from '@blocksuite/affine-block-surface';
import { type BlockSnapshot } from '@blocksuite/store';

export class EdgelessClipboardAttachmentConfig extends EdgelessClipboardConfig {
  static override readonly key = 'affine:attachment';

  override async prepareBlock(
    attachment: BlockSnapshot
  ): Promise<PreparedEdgelessBlock | null> {
    if (!this.surface) return null;

    const {
      xywh,
      rotate,
      sourceId,
      name,
      size,
      type,
      embed,
      style,
      pdfTextHighlights,
      pdfSignaturePlacements,
    } = attachment.props;

    if (!(await this.std.workspace.blobSync.get(sourceId as string))) {
      return null;
    }
    // The blob is checked before the paste writes; the write itself is
    // synchronous, in the transaction of the whole paste.
    return {
      create: () => {
        const surface = this.surface;
        if (!surface) return null;
        return this.crud.addBlock(
          'affine:attachment',
          {
            xywh,
            rotate,
            sourceId,
            name,
            size,
            type,
            embed,
            style,
            pdfTextHighlights,
            pdfSignaturePlacements,
          },
          surface.model.id
        );
      },
    };
  }
}
